module.exports = __webpack_public_path__ + "img/germany-diseases-of-the-nervous-system-female.d722f4b8.png";